var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('lazy-background',{staticStyle:{"position":"fixed"},attrs:{"src":"bg.jpg"}}),_c('v-overlay',{attrs:{"z-index":"0"}}),(_vm.$route.name !== 'Login')?_c('navbar'):_vm._e(),_c('transition',{attrs:{"mode":"out-in","name":"fade"}},[_c('router-view')],1),_c('toaster')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }